<template>
  <!-- A player as lists and the game page show them: a drawn stone of their colour, then the name
       (#seat-you for the viewer, #seat-empty for a colour nobody plays). -->
  <span class="player-name"><span class="stone" :class="colour"></span><span class="name" :class="{ empty: !player }">{{ label }}</span></span>
</template>

<script>
import { t } from '@/texts';

export default {
  name: 'PlayerName',
  props: { colour: { type: String, required: true }, player: Object, you: Boolean },
  computed: {
    label() {
      if (!this.player) return t('seat-empty');
      return this.you ? t('seat-you') : this.player.displayName;
    },
  },
};
</script>

<style scoped>
.player-name { display: inline-flex; align-items: center; min-width: 0; }
.name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.name.empty { color: #999; }
</style>
